import { useEffect, useState } from 'react';
import HealthService from '@/domain/Health/HealthService';
import { InfrastructureHealthResponse, SourcesKpisHealth } from '@/domain/Health/HealthTypes';

interface UseSourcesHealthOptions {
	page?: number;
	pageSize?: number;
	autoFetch?: boolean;
	parameterId?: number;
	search?: string;
}

export function useSourcesHealth(options: UseSourcesHealthOptions = {}) {
	const { page = 1, pageSize = 10, autoFetch = true, search } = options;


	const [healthData, setHealthData] = useState<InfrastructureHealthResponse | null>(null);
	const [healthKpi, setHealthKpi] = useState<SourcesKpisHealth | null>(null);
	const [dateOfLastFetch, setDateOfLastFetch] = useState<Date>(new Date());


	const fetchInfrastructuresHealth = async (
		fetchPage: number = page,
		fetchSize: number = pageSize,
		parameterId?: number,
		fetchSearch: string | undefined = search,
	): Promise<InfrastructureHealthResponse | undefined> => {
		try {
			const service = new HealthService();
			const response = await service.getInfrastructuresHealth(
				fetchPage,
				fetchSize,
				parameterId,
				fetchSearch,
			);
			setHealthData(response);
			setDateOfLastFetch(new Date());
			return response;
		} catch (err: unknown) {
			console.error('Error fetching infrastructures health:', err);
			return undefined;
		}
	};


	const fetchHealthKpi = async (): Promise<void> => {
		try {
			const service = new HealthService();
			const response = await service.getSourcesKpisHealth();
			setHealthKpi(response);
		} catch (err: unknown) {
			console.error('Error fetching health KPIs:', err);
		}
	};


	useEffect(() => {
		if (autoFetch) {
			void fetchInfrastructuresHealth();
		}
	}, [page, pageSize, autoFetch, search]);


	useEffect(() => {
		void fetchHealthKpi();
	}, []);

	return {

		healthData,
		healthKpi,
		dateOfLastFetch,
		

		fetchHealthData: fetchInfrastructuresHealth,
		fetchHealthDataByParameterId: (parameterId: number, fetchPage?: number, fetchSize?: number) =>
			fetchInfrastructuresHealth(fetchPage, fetchSize, parameterId),
	};
}
